export const getCompactNumberFormat = (number: number): string => {
  const formatter = Intl.NumberFormat('en', {
    notation: 'compact',
    maximumFractionDigits: 0,
  });

  return formatter.format(number);
};
